import React, { useState } from "react";
import UploadCropImg from "../../../commonComponents/upload-crop-img/uploadCropImg";
import { useDispatch, useSelector } from "react-redux";
import "./addDish.scss";

function AddDish({
  onCancel,
  restaurantName,
  menuSectionIndex,
  setReloadDishes,
  setToggleAddingDishbutton,
}) {
  const restaurantState = useSelector((state) => state.restaurantReducer);
  const dispatch = useDispatch();
  const [dishName, setDishName] = useState("");
  const [dishNameError, setDishNameError] = useState("");
  const [dishDescription, setDishDescription] = useState("");
  const [dishDescriptionError, setDishDescriptionError] = useState("");
  const [dishPrice, setDishPrice] = useState("");
  const [dishPriceError, setDishPriceError] = useState("");
  const [validationError, setValidationError] = useState("");

  function sendToServer() {
    console.log({ menuSectionIndex });
    console.log({ restaurantName });

    // Validate dishName
    if (!dishName.trim()) {
      setDishNameError("Dish Name is required");
      return;
    } else if (dishName.trim().length < 2 || dishName.trim().length > 80) {
      setDishNameError("Dish Name should be between 2 and 80 characters");
      return;
    } else {
      setDishNameError("");
    }

    // Validate dishDescription
    if (!dishDescription.trim()) {
      setDishDescriptionError("Dish Description is required");
      return;
    } else if (dishDescription.trim().length > 180) {
      setDishDescriptionError(
        "Dish Description should be 180 characters or less"
      );
      return;
    } else {
      setDishDescriptionError("");
    }

    // Validate dishPrice
    if (!dishPrice.trim() || isNaN(dishPrice) || parseFloat(dishPrice) <= 0) {
      setDishPriceError("Dish Price should be a positive number");
      return;
    } else {
      setDishPriceError("");
    }

    const formData = new FormData();
    if (restaurantState.croppedImageUrl.croppedImageUrl) {
      formData.append(
        "dishImage",
        restaurantState.croppedImageUrl.croppedImageUrl,
        restaurantName
      );
    }
    formData.append("dishName", dishName);
    formData.append("dishDescription", dishDescription);
    formData.append("dishPrice", dishPrice);
    formData.append("menuSectionIndex", menuSectionIndex);
    console.log(restaurantState.croppedImageUrl.croppedImageUrl);
    const blob = restaurantState.croppedImageUrl?.croppedImageUrl;
    console.log(blob);
    const dishArray = JSON.parse(sessionStorage.getItem("dishes")) || [];

    // Use FileReader to read the blob as a data URL
    const reader = new FileReader();

    reader.onload = function () {
      const dishObject = {
        img: blob ? reader.result : null, // Use reader.result if blob is truthy, otherwise null
        dishName,
        dishDescription,
        dishPrice,
        menuSectionIndex,
      };

      // Push the new dish object to the array
      dishArray.push(dishObject);

      // Convert the array to a JSON string
      const dishArrayString = JSON.stringify(dishArray);

      // Store the updated array in sessionStorage
      sessionStorage.setItem("dishes", dishArrayString);
      setReloadDishes(true);
      setToggleAddingDishbutton(false);
      dispatch({
        type: "ADD_UPLOAD_CROPED_IMG",
        payload: {
          croppedImageUrl: "",
        },
      });
    };

    // Read the blob as a data URL
    if (blob) {
      reader.readAsDataURL(blob);
    } else {
      // If blob is undefined, trigger the onload function immediately with a null result
      reader.onload();
    }

   
  }

  return (
    <div className="AddDish-container">
      <div className="AddDish-form">
        <h1>Add a dish</h1>
        <div className="form-group">
          <input
            value={dishName}
            onChange={(e) => setDishName(e.target.value)}
            placeholder="Dish Name *"
            id="dishName"
          />
          {dishNameError && (
            <span className="error-message">{dishNameError}</span>
          )}
        </div>

        <div className="form-group">
          <textarea
            value={dishDescription}
            onChange={(e) => setDishDescription(e.target.value)}
            placeholder="Dish description *"
            id="dishDescription"
          ></textarea>
          {dishDescriptionError && (
            <span className="error-message">{dishDescriptionError}</span>
          )}
          <div className="char-count">
            {dishDescription.length}/180 characters
          </div>
        </div>

        <div className="form-group">
          <input
            value={dishPrice}
            onChange={(e) => setDishPrice(e.target.value)}
            type="number"
            placeholder="Dish price *"
            id="dishPrice"
          />
          {dishPriceError && (
            <span className="error-message">{dishPriceError}</span>
          )}
        </div>
        {validationError && (
          <span className="error-message" style={{ color: "red" }}>
            {validationError}
          </span>
        )}
        <UploadCropImg widthCrop={300} heightCrop={300} />

        <div className="form-actions">
          <button onClick={sendToServer}>Add</button>
          <button type="button" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddDish;
